<main>
  <section
    style="
      background-image: url('assets/images/irrigation-insurance-hero.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-start g-lg-5 py-5">
        <div class="col-lg-10 text-lg-start text-light">
          <h1 class="display-4 lh-1 mb-3 py-4">Irrigation Insurance</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container p-0">
    <div class="d-md-flex flex-md-equal w-100 my-md-5">
      <div class="overflow-hidden">
        <img
          src="assets/images/solutions-irrigation-insurance.jpg"
          alt="Farmer standing in rows of a healthy and green soybean field."
        />
      </div>
      <div class="px-3 px-md-5 overflow-hidden">
        <div class="mb-3 p-3">
          <p class="display-6 text-primary mb-4">
            Solutions and service to meet the demands of your operation.
          </p>
        </div>
        <div class="container mb-4" id="icon-grid">
          <div class="row row-cols-1 row-cols-sm-2 g-4 text-small">
            <div class="col d-flex align-items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-check text-primary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                />
              </svg>
              <div class="ps-1" style="width: 95%">
                <p>
                  Coverage protects against the majority of direct physical
                  losses on protected property.
                </p>
              </div>
            </div>
            <div class="col d-flex align-items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-check text-primary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                />
              </svg>
              <div class="ps-1" style="width: 95%">
                <p>
                  Claims are handled fast and fair by our knowledgeable,
                  experienced staff.
                </p>
              </div>
            </div>
            <div class="col d-flex align-items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-check text-primary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                />
              </svg>
              <div class="ps-1" style="width: 95%">
                <p>
                  Unlike most of our competitors, our policies do not depreciate
                  the value of your equipment.
                </p>
              </div>
            </div>
            <div class="col d-flex align-items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-check text-primary"
                viewBox="0 0 16 16"
              >
                <path
                  d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                />
              </svg>
              <div class="ps-1" style="width: 95%">
                <p>
                  Structural damage (mechanical or electrical) coverage is
                  available for qualifying equipment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="container-fluid bg-primary px-5 mb-5"
    style="margin-top: 175px; padding-bottom: 100px"
  >
    <div class="row justify-content-center">
      <div
        class="d-md-flex flex-md-equal w-100 ps-md-3"
        style="margin-top: -100px; max-width: 1400px"
      >
        <div class="bg-secondary pt-3 pb-4 px-3 px-md-5 overflow-hidden">
          <div class="my-3 p-3">
            <h2 class="fs-4 mb-4">File a Claim</h2>
            <p class="mb-4">
              We value customer service. Report a claim anytime, and we'll help
              you manage the process.
            </p>
            <a
              class="btn btn-primary"
              href="javascript:void(0)"
              (click)="downloadClaimPacket()"
              >Learn More</a
            >
          </div>
        </div>
        <div class="bg-success pt-3 pb-4 px-3 px-md-5 overflow-hidden">
          <div class="my-3 py-3">
            <h2 class="fs-4 mb-4">Get a Quote</h2>
            <p class="mb-4">
              Let us know about your operation so we can address your insurance
              coverage requirements.
            </p>
            <a class="btn btn-primary" routerLink="/get-quote">Learn More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
